import { render, staticRenderFns } from "./AudienceAndTopupAiBroadcast.vue?vue&type=template&id=f63cdd28&scoped=true&"
import script from "./AudienceAndTopupAiBroadcast.vue?vue&type=script&lang=js&"
export * from "./AudienceAndTopupAiBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./AudienceAndTopupAiBroadcast.vue?vue&type=style&index=0&id=f63cdd28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63cdd28",
  null
  
)

export default component.exports